import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../http";

type ImproveCheckbox = {
  reason: string;
  id: string;
};

async function getUserDeleteReasons() {
  const res = await api.auth.get<Array<ImproveCheckbox>>(
    "services/cancellation-reasons/",
    {
      searchParams: { source: "account_delete" },
    },
  );

  return await res.json();
}

export const userDeleteReasonsQueryOptions = queryOptions<
  Array<ImproveCheckbox>
>({
  queryKey: ["deletion-reasons"],
  queryFn: getUserDeleteReasons,
});

export function useUserDeleteReasons() {
  return useQuery(userDeleteReasonsQueryOptions);
}
